// eslint-disable-next-line import/no-anonymous-default-export
export default {
  toolsTitle: 'HitPaw Online Ultimate',
  fileSizeLimitTitle:
    'O tamanho do arquivo para conta gratuita não pode exceder 20 MB.',
  freeTimesLimitTitle: 'O teste da conta gratuita termina hoje.',
  freeImgCutoutTimesLimitTitle:
    'A chance de remover fundo foi esgotada hoje, por favor, atualize para Pro para acessar todos os recursos premium',
  total: 'Total',
  enterCode: 'Digitar o código',
  signUpToPurchaseBtn: 'Registrar-se para comprar',
  goPurchseBtn: 'Ir para comprar',
  saveTips: 'Economizar até {{num}}%.',
  discount: 'Desconto',
  priceWeek: 'R$59,99',
  priceMonth: 'R$39,99',
  priceYear: 'R$19,99',
  billedMonth: 'R$159,99 Pagos Mensalmente',
  billedYear: 'R$929,99 Pagos Anualmente',
  monthly: 'Mensualmente',
  yearly: 'Anualmente',
  weekly: 'Semanalmente',
  week: 'Semana',
  AlreadySubscribe: 'Já inscrevi?',
  vipTips1: 'Sem limites de tamanho de arquivo',
  vipTips2: 'Processe a quantidade de arquivos sem limites',
  vipTips3: 'Altere os fundos das imagens sem limites',
  vipTips4: 'Acesso a todas as ferramentas gratuitas e recursos premium',
  purchaseTips: 'Renovar automaticamente e cancelar a qualquer momento.',
  tips: 'Dicas:',
  promoCodeInvalidTips: 'Seu código de promoção é inválido',
  //2022.09.28 xxy
  freeImgBgChangerTimesLimitTitle:
    'Today’s trial oppotunity for changing background has been run out, please upgrade to Pro to access all premium features',
  vipBgChangerTips: 'Change image backgrounds without limits',
};
